/* Khan's Scroll-Reveal + Micro-Animations v2
   EINZIGES Reveal-System des Themes.
   - übernimmt auch Legacy-.kv-Elemente (vorher eigenes System in khans-styles)
   - respektiert prefers-reduced-motion
   - Easing/Timing nach Motion-Guidelines: 200–650ms, transform/opacity only */
(function () {
  'use strict';
  if (!window.IntersectionObserver) return;
  if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

  /* CSS wird per JS injiziert → ohne JS bleibt alles sichtbar (kein FOIC) */
  var s = document.createElement('style');
  s.textContent = '@media(prefers-reduced-motion:no-preference){' +
    '.kr{opacity:0;transform:translateY(22px);transition:opacity .6s cubic-bezier(.16,1,.3,1),transform .6s cubic-bezier(.16,1,.3,1);transition-delay:var(--d,0s);}' +
    '.kr.kr-v{opacity:1;transform:none;}' +
    '.kr-l{opacity:0;transform:translateX(-20px);}' +
    '.kr-r{opacity:0;transform:translateX(20px);}' +
    '.kr-l.kr-v,.kr-r.kr-v{opacity:1;transform:none;}' +
    '}';
  document.head.appendChild(s);

  /* Karten — gestaffelt innerhalb des Parents */
  var CARDS = [
    '.kx-c', '.km-card', '.km-pkg', '.ke-item',
    '.kc-card', '.kb-rv', '.kb-pkg', '.kb-proc-step',
    '.kb-card', '.kb-ind-card', '.kk-alt-item'
  ];

  /* Blöcke — einfacher Fade-up (inkl. Legacy .kv) */
  var BLOCKS = [
    '.kv',
    '.kx-head', '.km-hero', '.km-banner', '.km-incl', '.km-cta',
    '.km-offers-sub', '.km-pkgs-title', '.ki-left', '.ki-right',
    '.kb-b2b-l', '.kb-b2b-r', '.kb-quote',
    '.kb-faq-item', '.kc-hero-txt', '.kc-incl', '.kc-proc', '.kc-cta',
    '.ke-head', '.ke-cta', '.kk-form-wrap', '.kk-alt', '.kk-trust',
    '.kx-foot', '.km-offers-title'
  ];

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('kr-v');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.07, rootMargin: '0px 0px -30px 0px' });

  function setup() {
    CARDS.forEach(function (sel) {
      var byParent = {};
      document.querySelectorAll(sel).forEach(function (el) {
        var k = el.parentElement ? (el.parentElement.dataset.panel || el.parentElement.className || 'g') : 'g';
        (byParent[k] = byParent[k] || []).push(el);
      });
      Object.keys(byParent).forEach(function (k) {
        byParent[k].forEach(function (el, i) {
          el.classList.add('kr');
          el.style.transitionDelay = (Math.min(i % 5, 4) * 0.07) + 's';
          obs.observe(el);
        });
      });
    });

    BLOCKS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.classList.contains('kr')) return; /* nicht doppelt registrieren */
        el.classList.add('kr');
        obs.observe(el);
      });
    });

    /* Katalog-Tabwechsel — Reveal erneut abspielen */
    document.querySelectorAll('.kx-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tab = pill.getAttribute('data-tab');
        var panel = document.querySelector('[data-panel="' + tab + '"]');
        if (!panel) return;
        panel.querySelectorAll('.kr').forEach(function (el, i) {
          el.classList.remove('kr-v');
          el.style.transitionDelay = (Math.min(i % 5, 4) * 0.07) + 's';
          setTimeout(function () { obs.observe(el); }, 10);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else { setup(); }
})();
